import { Card, CardContent } from "@/components/ui/card";
import { TrendingUp } from "lucide-react";

const colorVariants = {
  blue: {
    bg: "from-blue-500 to-blue-600",
    accent: "bg-blue-100 text-blue-700",
    icon: "text-blue-600",
  },
  red: {
    bg: "from-red-500 to-red-600",
    accent: "bg-red-100 text-red-700",
    icon: "text-red-600",
  },
  green: {
    bg: "from-green-500 to-green-600",
    accent: "bg-green-100 text-green-700",
    icon: "text-green-600",
  },
  orange: {
    bg: "from-orange-500 to-orange-600",
    accent: "bg-orange-100 text-orange-700",
    icon: "text-orange-600",
  },
  purple: {
    bg: "from-purple-500 to-purple-600",
    accent: "bg-purple-100 text-purple-700",
    icon: "text-purple-600",
  },
};

export default function StatsCard({
  title,
  value,
  icon: Icon,
  trend,
  color = "blue",
  urgent = false,
  subtitle = null,
}) {
  // Fallback to blue if color doesn't exist
  const colorScheme = colorVariants[color] || colorVariants.blue;

  return (
    <Card
      className={`relative overflow-hidden transition-all duration-300 hover:shadow-xl bg-white/60 backdrop-blur-sm border-slate-200/60 ${urgent ? "ring-2 ring-orange-200" : ""}`}
    >
      <div
        className={`absolute top-0 right-0 w-24 h-24 bg-gradient-to-br ${colorScheme.bg} opacity-10 rounded-full transform translate-x-8 -translate-y-8`}
      />

      <CardContent className="p-6 relative">
        <div className="flex items-start justify-between">
          <div className="space-y-2">
            <p className="text-sm font-medium text-slate-600">{title}</p>
            <p className="text-3xl font-bold text-slate-900">{value}</p>
            {subtitle && <p className="text-xs text-slate-500">{subtitle}</p>}
          </div>
          <div
            className={`p-3 rounded-xl bg-gradient-to-br ${colorScheme.bg} shadow-lg`}
          >
            <Icon className="w-6 h-6 text-white" />
          </div>
        </div>

        {trend && (
          <div className="flex items-center mt-4 text-sm">
            <TrendingUp className="w-4 h-4 mr-1 text-green-500" />
            <span className="text-green-600 font-medium">{trend}</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
